// checkNetworkSpeed.js
'use strict';
import getOperationData from '../selector/getOperationData.js';
import trackMixpanel, { EventTypes } from '../resource/mixpanel.js';
import { Speedtest } from 'speedtest/speedtest.js';
import { MERGE_OPERATION_DATA, REMOVE_OPERATION_DATA } from '../ActionTypes.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import getCurrentUnixTimestamp from '../resource/getCurrentUnixTimestamp.js';
import getCurrentLanguage from '../resource/getCurrentLanguage.js';

let speedtestServer = {
  name: 'SWAG',
  server: `${location.protocol}//${location.host}/`,

  dlURL: 'speedtest/garbage.php',
  ulURL: 'speedtest/empty.php',
  pingURL: 'speedtest/empty.php',
  getIpURL: 'speedtest/getIP.php',
};

let speedtest = undefined;

/**
 * Check network speed
 * @kind action
 * @return {Promise} Action promise.
 */
const checkNetworkSpeed = () => async dispatch => {
  if (!speedtest) {
    speedtest = new Speedtest();
    const currentLanguage = getCurrentLanguage();
    // append lang query to avoid backend redirection
    speedtestServer['dlURL'] += `?lang=${currentLanguage}`;
    speedtestServer['ulURL'] += `?lang=${currentLanguage}`;
    speedtestServer['pingURL'] += `?lang=${currentLanguage}`;
    speedtestServer['getIpURL'] += `?lang=${currentLanguage}`;

    speedtest?.setSelectedServer(speedtestServer);
    speedtest.onupdate = data => {
      if (!data) return;

      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['speedtest'],
          data: {
            clientIp: data.clientIp,
            dlProgress: data.dlProgress,
            ulProgress: data.ulProgress,
            pingStatus: data.pingStatus,
            jitterStatus: data.jitterStatus,
            dlStatus: data.dlStatus,
            ulStatus: data.ulStatus,
            testState: data.testState,
          },
        },
      });
    };
    speedtest.onend = aborted => {
      if (aborted) {
        // reset
        dispatch({
          type: REMOVE_OPERATION_DATA,
          payload: {
            selectPath: ['speedtest'],
          },
        });
      }
      return dispatch(setSpeedtestUnixTimestamp());
    };
  }

  speedtest?.start();

  return dispatch({ type: '' });
};

const setSpeedtestUnixTimestamp = () => async (dispatch, getState) => {
  const timestampOffsetSeconds = getTimestampOffset(
    getState(),
    Accuracy.SECOND
  );
  return dispatch({
    type: MERGE_OPERATION_DATA,
    payload: {
      selectPath: ['speedtest'],
      data: {
        speedtestUnixTimestamp: getCurrentUnixTimestamp({
          offsetSeconds: timestampOffsetSeconds,
        }),
      },
    },
  });
};

export const trackSpeedtestEvent = () => async (dispatch, getState) => {
  const drmTestResult = getOperationData(getState(), ['drm'], 'testResult');
  const initSpped = getOperationData(
    getState(),
    ['pusher', 'stats'],
    'initSpeed'
  );
  const connectSpeed = getOperationData(
    getState(),
    ['pusher', 'stats'],
    'connectSpeed'
  );
  const jitterStatus = getOperationData(
    getState(),
    ['speedtest'],
    'jitterStatus'
  );
  const pingStatus = getOperationData(getState(), ['speedtest'], 'pingStatus');
  const dlProgress = getOperationData(getState(), ['speedtest'], 'dlProgress');
  const ulProgress = getOperationData(getState(), ['speedtest'], 'ulProgress');
  const dlStatus = getOperationData(getState(), ['speedtest'], 'dlStatus');
  const ulStatus = getOperationData(getState(), ['speedtest'], 'ulStatus');
  const testState = getOperationData(getState(), ['speedtest'], 'testState');

  return trackMixpanel({
    type: EventTypes.USER_DEBUG_SENT,
    payload: {
      drmTestResult,
      speedtestResult: {
        jitterStatus,
        pingStatus,
        dlProgress,
        ulProgress,
        dlStatus,
        ulStatus,
        testState,
      },
      pusherStatsResult: {
        initSpped,
        connectSpeed,
      },
    },
  });
};

export default checkNetworkSpeed;
